import { useRef, useState } from 'react';
import { uploadFile } from '../../../functions/Api';
import { Button } from '@asu/unity-react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const UploadByFile = (props) => {
  const [file, setUploadFile] = useState(null);
  const fileInputRef = useRef(null);

  const clearFileInput = () => {
    setUploadFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const uploadFiles = async () => {
    props.setUploading(true);
    let hasError = false;

    for (const selectedClass of props.classes) {
      try {
        let result = await uploadFile(file, selectedClass);
        props.setUploadResults((results) => {
          return results.concat(result);
        });
      } catch (error) {
        hasError = true;
        let errors = props.errors;
        if (!errors.includes(error)) {
          errors.push('Error: ' + error);
        }
        props.setErrors(errors);
        props.setUploading(false);
        return error;
      }
    }

    if (!hasError) {
      props.updateSyllabusStatus();
    }

    props.setUploading(false);
  };

  const onChangeHandler = (event) => {
    setUploadFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (file) {
      uploadFiles();
    } else {
      alert('No file chosen');
    }
  };

  return (
    <div className="action-buttons mb-2">
      <div className="d-flex gap-1 mb-2">
        <input
          type="file"
          name="file"
          onChange={onChangeHandler}
          ref={fileInputRef}
          accept=".pdf,application/pdf"
        />
        {/** Display delete icon if there is an upload file */}
        {file && (
          <button
            value="remove"
            className="border-0 rounded-circle bg-transparent text-maroon"
            onClick={clearFileInput}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </div>
      <div>
        <Button label="Upload" color="maroon" onClick={handleUpload} />
      </div>
    </div>
  );
};

export default UploadByFile;
